import type { PushNotificationsSettings, YammerState } from '../../state/types';

type GetSettings = (state: YammerState) => PushNotificationsSettings;
export const getSettings: GetSettings = (state) => state.pushNotificationsSettings;
